<template>
  <v-menu offset-y style="z-index: 120">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom style="z-index: 120">
        <template v-slot:activator="{ on: tooltip }">
          <!-- v-bind="attrs" -->
          <v-btn class="text-none" outlined v-on="{ ...tooltip, ...menu }">
            {{ activeRoute }}
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('AppLayout.NavBar.Project.NavigationButton') }}</span>
      </v-tooltip>
    </template>
    <v-list>
      <TTooltip 
        :value="getToolTip({ disabled: handlePermission(item), pro_account: !hasPermission(item.permission), name: item.title })"
        v-for="(item, index) in items" :key="index"
      >
        <v-list-item  @click="navigate(item)"
          :disabled="handlePermission(item)">
          <v-list-item-icon>
            <TIcon :name="item.icon" />
          </v-list-item-icon>
          <TText :value="item.title" :font_weight="400"/>
        </v-list-item>
      </TTooltip>
    </v-list>
  </v-menu>
</template>
<script>
import { mapGetters } from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';

export default {
  name: 'ProjectMenu',
  props: ['project_id'],
  components: { TIcon, TTooltip },
  data: () => ({
    items: [
      { icon: 'takt-plan', title: 'TAKT.plan', permission: '', ppermission: '' },
      { icon: 'takt-wallet', title: 'TAKT.wallet', permission: '', ppermission: '' },
      { icon: 'takt-journal', title: 'TAKT.journal', permission: 'Taktjournal READ', ppermission: '' },
      { icon: 'takt-structure', title: 'PROJECT.structure', permission: '', ppermission: '' },
      { icon: 'takt-autopilots', title: 'PROJECT.autopilots', permission: 'Autopilot READ', ppermission: 'Read Autopilots' },
      { icon: 'takt-settings', title: 'PROJECT.settings', permission: '', ppermission: '' },
      // { icon: 'takt-autopilots', title: 'PROJECT.wallet-print', permission: '', ppermission: '' },
    ],
  }),
  computed: {
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex',
    ]),
    ...mapGetters('View', [
      'isSvgIcon',
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
    ]),
    ...mapGetters('Project', [
      'hasProjectPermission',
    ]),
    activeRoute: function () {
      let name = '';
      switch (this.$route.matched[1].name) {
        case 'ProjectTaktPlan':
          name = 'TAKT.plan';
          break;
        case 'ProjectWallet':
          name = 'TAKT.wallet';
          break;
        case 'ProjectTaktJournal':
          name = 'TAKT.journal';
          break;
        case 'ProjectStructure':
          name = 'PROJECT.structure';
          break;
        case 'ProjectAutoPilots':
          name = 'PROJECT.autopilots';
          break;
        case 'ProjectSettings':
          name = 'PROJECT.settings';
          break;
        case 'ProjectWalletPrint':
        name = 'PROJECT.wallet-print';
        break;
      }
      return name;
    }
  },
  methods: {
    getToolTip(item) {
      if (item.disabled) {
        if (item.pro_account) {
          return `${item.name} are part of the TAKT.ing PRO.account.`;
        }
        return `Your PROJECT.role is not allowed to use ${item.name}.`;
      }
      return `${item.name}`;
    },
    handlePermission(item) {
      if (item.permission == '' && item.ppermission == '') {
        return false;
      }
      let disabled = false;
      if (item.permission) {
        disabled = !this.hasPermission(item.permission);
        if (disabled) {
          return disabled;
        }
      }
      if (item.ppermission) {
        disabled = !this.hasProjectPermission({ project_id: this.$route.params.project_id, ppermission: item.ppermission });
      }
      return disabled;
    },
    navigate(item) {
      let to = 'ProjectTaktPlan';
      let params = {
        project_id: this.project_id
      }
      switch (item.title) {
        case 'TAKT.plan':
          to = 'ProjectTaktPlan';
          break;
        case 'TAKT.wallet':
          to = 'ProjectWalletTakt';
          params.takt_index = this.getCurrentTaktIndex(this.project_id) !== false ?
            Math.abs(this.getCurrentTaktIndex(this.project_id)) : 1
          break;
        case 'TAKT.journal':
          to = 'ProjectTaktJournal';
          break;
        case 'PROJECT.structure':
          to = 'ProjectStructure';
          break;
        case 'PROJECT.autopilots':
          to = 'ProjectAutoPilots';
          break;
        case 'PROJECT.settings':
          to = 'ProjectSettings';
          break;
        case 'PROJECT.wallet-print':
        params.workpackage_id = 0;
        to = 'ProjectWalletPrint';
        break;
      }
      this.$router.push({
        name: to,
        params: params
      });
    }
  }
}
</script>
